// extracted by mini-css-extract-plugin
export default {"wrapper":"Message_wrapper__1bTwf","avatar":"Message_avatar__AH7Zk"};